import axios from 'axios';
import { apiUrl } from '@qwealth/qdata';
import { responseEntityMapper } from '@qwealth/qcore';
import { EntityFinancialModels } from '../types';

export const loadFinancialModels = async (partnerID: string, strategy: string, mandate: string) =>
  await axios
    .get(`${apiUrl}/financialModels/portfolio`, { params: { partnerID, strategy, mandate } })
    .then(response => responseEntityMapper<EntityFinancialModels>(response));
